import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import type { AiqDomainAnalysis, AiqTimeAnalysis } from '../../types/aiq-report'

const DOMAIN_LABELS: Record<string, string> = {
  abstraction: '무시',
  change: '변화',
  relation: '관계',
}

interface Props {
  timeAnalysis: AiqTimeAnalysis
  domainData: AiqDomainAnalysis[]
}

export function TimeAnalysisChart({ timeAnalysis, domainData }: Props) {
  const chartData = [
    {
      name: '전체 평균',
      'Pre-AIQ': Math.round(timeAnalysis.preAvgTimeSec),
      'Post-AIQ': Math.round(timeAnalysis.postAvgTimeSec),
    },
    ...domainData.map(d => ({
      name: DOMAIN_LABELS[d.domain] || d.domain,
      'Pre-AIQ': Math.round(d.preAvgTimeSec),
      'Post-AIQ': Math.round(d.postAvgTimeSec),
    })),
  ]

  const formatTime = (seconds: number) => {
    if (seconds < 60) return `${seconds}초`
    const min = Math.floor(seconds / 60)
    const sec = seconds % 60
    return sec > 0 ? `${min}분 ${sec}초` : `${min}분`
  }

  return (
    <div className="p-6 bg-white rounded-xl shadow-2xs border border-gray-100">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">소요 시간 분석</h3>
        {timeAnalysis.timeImprovedPercent > 0 && (
          <span className="px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full">
            {timeAnalysis.timeImprovedPercent.toFixed(1)}% 단축
          </span>
        )}
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={chartData} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
          <XAxis dataKey="name" tick={{ fontSize: 13 }} />
          <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => `${v}초`} />
          <Tooltip
            formatter={((value: number, name: string) => [formatTime(value), name]) as never}
          />
          <Legend wrapperStyle={{ fontSize: 13 }} />
          <Bar dataKey="Pre-AIQ" fill="#93c5fd" radius={[4, 4, 0, 0]} />
          <Bar dataKey="Post-AIQ" fill="#c4b5fd" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
